module.exports = __webpack_public_path__ + "static/media/gb-wls.1df6a456.svg";